export const PROGRESS_STEPS = [
  'External Document',
  'Internal Document',
  'Configuration'
];
